import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getCompanyProfile, updateCompanyProfile } from "@/features/settings/api/companyProfile";
import { useMutation } from "@tanstack/react-query";
import { showErrorFromMutation, showSuccess } from "@/shared/utils/toast";

// use company profile hook
export const useCompanyProfile = () => {
  return useQuery({
    queryKey: ["companyProfile"],
    queryFn: getCompanyProfile,
  });
};

// use update company profile hook
export const useUpdateCompanyProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCompanyProfile,
    onError: (error) => {
      showErrorFromMutation(error, error.message || "Failed to update company profile.");
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["companyProfile"] });
      showSuccess("Company profile updated successfully!");
      return data;
    },
  });
};